module.exports = __webpack_public_path__ + "static/0025-1875f2cb989387bcbbd3d5e1bf182527.png";